<template>
   <g>
      <path
         d="M2.22461 12.6631C1.83529 12.6631 1.49674 12.5742 1.20898 12.3965C0.921224 12.223 0.69694 11.9902 0.536133 11.6982C0.375326 11.4062 0.294922 11.0868 0.294922 10.7397C0.294922 10.4012 0.381673 10.0796 0.555176 9.7749L5.44922 1.23096C5.62695 0.913574 5.86605 0.674479 6.1665 0.513672C6.46696 0.348633 6.78011 0.266113 7.10596 0.266113C7.4318 0.266113 7.74284 0.346517 8.03906 0.507324C8.33529 0.668132 8.5765 0.909342 8.7627 1.23096L13.6504 9.76855C13.7393 9.92513 13.8049 10.0859 13.8472 10.251C13.8895 10.4118 13.9106 10.5747 13.9106 10.7397C13.9106 11.0868 13.8302 11.4062 13.6694 11.6982C13.5129 11.9902 13.2907 12.223 13.0029 12.3965C12.7152 12.5742 12.3766 12.6631 11.9873 12.6631H2.22461ZM7.1123 8.11816C7.5651 8.11816 7.8042 7.88542 7.82959 7.41992L7.9375 4.68408C7.94596 4.4471 7.87191 4.25456 7.71533 4.10645C7.55876 3.9541 7.35563 3.87793 7.10596 3.87793C6.85205 3.87793 6.64681 3.95199 6.49023 4.1001C6.33789 4.24821 6.26807 4.44076 6.28076 4.67773L6.38232 7.42627C6.40771 7.88753 6.65104 8.11816 7.1123 8.11816ZM7.1123 10.416C7.36621 10.416 7.5778 10.342 7.74707 10.1938C7.92057 10.0457 8.00732 9.85107 8.00732 9.60986C8.00732 9.36865 7.92057 9.17399 7.74707 9.02588C7.5778 8.87777 7.36621 8.80371 7.1123 8.80371C6.8584 8.80371 6.64469 8.87777 6.47119 9.02588C6.29769 9.17399 6.21094 9.36865 6.21094 9.60986C6.21094 9.85107 6.29769 10.0457 6.47119 10.1938C6.64893 10.342 6.86263 10.416 7.1123 10.416Z"
         fill="#DC3545"
      />
   </g>
</template>

<script>
export default {
   data() {
      return {
         name: 'icon-alert',
         viewBox: '0 0 14 13',
         width: 14,
         height: 13,
         fill: 'none',
      };
   },
};
</script>
